import { Spin } from 'antd';
import styled from 'styled-components';

export const StyledInfiniteScrollSpin = styled(Spin)`
  padding: ${(props): string => props.theme.spacing.base};
  margin: ${(props): string => props.theme.spacing.base};
  ${(props): string => props.theme.mixins.flexCenter}
`;
